import { render, staticRenderFns } from "./TheCoursesMenu.vue?vue&type=template&id=f47f25fa&scoped=true&"
import script from "./TheCoursesMenu.vue?vue&type=script&lang=js&"
export * from "./TheCoursesMenu.vue?vue&type=script&lang=js&"
import style0 from "./TheCoursesMenu.vue?vue&type=style&index=0&id=f47f25fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47f25fa",
  null
  
)

export default component.exports